import { Box, Typography } from "@mui/material";
import { qualityList } from "../../shared/constent/constent";
import CardComponent from "../shared/cardlistcomponent";

const Index = () => {

    return (
        <Box px={4} py={2} height="calc(100vh - 116)" mt={1.5}>
            <Typography variant="h6" sx={{ fontWeight: "bold", pb: 2 }}>
                Quality
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {qualityList?.map((item, index) => (
                    <CardComponent key={index} data={item} />
                ))}
            </Box>
        </Box>
    )
}

export default Index;